import styles from "./index.module.scss";
import { NextPage } from "next";
import StockEps from "@/components/stock-eps/StockEps";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockEpsPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);
    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "EPS Momentum");
                    return (
                        <Head>
                            <title>{`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | EPS Momentum | ORTEX`}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "eps")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, EPS Momentum`} />
                            <meta name="description" content={`Earnings Per Share, EPS, Momentum for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | EPS Momentum | ORTEX`} />
                            <meta name="twitter:description" content={`Earnings Per Share, EPS, Momentum for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "eps")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | EPS Momentum | ORTEX`} />
                            <meta property="og:description" content={`Earnings Per Share, EPS, Momentum for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "eps")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockEpsPage}>{stock ? <StockEps stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "eps", allowedTypes: [1] });

export default StockEpsPage;
